<template>
  <div>
    <headerBreadCrumbs :breadCrumbs="breadCrumbs" title="Mass Notification" />

    <div class="row mb-4">
      <div class="col-md-12 mb-4">
        <div class="card text-left mb-4">
          <div class="card-body">
            <div class="mb-4">
              <div class="d-flex flex-row justify-content-between">
                <span class="h4"><b>View Details</b></span>
                <div class="d-flex flex-column flex-wrap">
                  <button class="btn" :class="{ 'btn-danger': mass_notification.status, 'btn-secondary': !mass_notification.status }" :disabled="!mass_notification.status" type="type" @click="stopNotification">Stop</button>
                  <small class="" v-if="!mass_notification.status">{{ `Stopped at ${mass_notification.stopped_at_formatted}` }}</small>
                </div>

              </div>
            </div>

            <div class="row px-3 mb-4">
              <LabelValue :classCustom="'col-4'" label="Title:" :value="mass_notification.title" />
              <LabelValue :classCustom="'col-4'" label="Start Date:" :value="mass_notification.start_date | moment('DD/MM/YYYY')" />
            </div>

            <div class="row px-3 mb-4">
              <LabelValue :classCustom="'col-4'" label="Description:" :value="mass_notification.description" />
              <LabelValue :classCustom="'col-4'" label="End Date:" :value="mass_notification.end_date | moment('DD/MM/YYYY')" />
            </div>

            <div class="row px-3 mb-4">
              <LabelValue :classCustom="'col-4'" label="Note to user:" :value="mass_notification.notes" />
              <LabelValue :classCustom="'col-4'" label="Time:" :value="mass_notification.time_formatted" />
            </div>

            <div class="row px-3 mb-4">
              <LabelValue :classCustom="'col-4'" label="Award Points:" :value="`${mass_notification.type_text} ${mass_notification.award_points == null ? '' : ` - ${mass_notification.award_points}`}`" />
            </div>

            <div class="px-3 mb-4">
              <input class="mr-2" type="checkbox" id="send_sms" :checked="mass_notification.send_sms" disabled="true">
              <label class="mr-4" :for="`send_sms`">Send SMS to non-existing users</label>
            </div>

            <Conditions :meta_conditions="meta_conditions" />

            <hr />

            <div v-if="useExcel">
              <SelectedUser :buttons="buttons" :handleButtonClick="onPressBtn" :mainData="data" :selectedIndex="selectedIndex" @update:mainData="updateData" />
            </div>

            <div v-else>
              <NonSelectedUser :buttons="buttons" :handleButtonClick="onPressBtn" :mainData="data" :selectedIndex="selectIndexNonExcel" :massNotificationId="notification_id"/>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import headerBreadCrumbs from '../../../components/headerBreadCrumbs.vue';
import InputLabel from '../../../components/UI/InputLabel.vue';
import { getMassNotificationDetails, stopMassNotification } from '../../../services/MassNotificationService';
import LabelValue from '../../../components/UI/LabelValue.vue';
import SelectedUser from './users/main.vue';
import Conditions from './conditions.vue';
import NonSelectedUser from './non-selected-users/main.vue';

export default {
  components: { headerBreadCrumbs, InputLabel, LabelValue, SelectedUser, Conditions, NonSelectedUser },

  data() {
    return {
      breadCrumbs: [
        { name: 'Marketing', path: null },
        { name: 'Mass Notification', path: '/marketing/mass-notification' },
        { name: 'Add New', path: null },
      ],

      mass_notification: {
        status: 1
      },

      meta_conditions: [],

      data: {},

      buttons: [
        { status: true, name: "All" },
        { status: false, name: "Existing" },
        { status: false, name: "Non-Existing" },
        { status: false, name: "Newly Registered" },
        { status: false, name: "Purchases" },
        { status: false, name: "Redeemed" },
      ],
      selectedIndex: 0,
      selectIndexNonExcel: 0,

      notification_id: this.$route.params.id,

      products: {},

      tableData: [],
      disabledSms: false,

      useExcel: false,
    }
  },

  watch: {
    selectedIndex(newIndex) {
      this.initializeCurrentTable();
    },

    selectIndexNonExcel(newIndex) {
      this.initializeData();
    }
  },

  methods: {
    async fetchData() {
      try {
        const response = await getMassNotificationDetails(this.notification_id);

        if (response.data.success) {
          this.data = response.data.data;
          this.useExcel = response.data.data.excel;
          this.meta_conditions = response.data.data.conditions;
          this.mass_notification = response.data.data.mass_notifications;
        }

      } catch (e) {
        console.error(e)
      }
    },


    updateTableData(newData) {
      this.tableData = newData;
    },

    onPressBtn(int, selectVariable, buttonArray) {
      this[selectVariable] = int;

      this[buttonArray].forEach((button, index) => {
        button.status = int === index;
      });
    },

    loadDatatable(tableId) {
      if ($.fn.DataTable.isDataTable(`#${tableId}`)) {
        $(`#${tableId}`).DataTable().destroy();
      }

      $(`#${tableId}`).DataTable({
        pageLength: 10,
        dom: "Bfrtip",
        buttons: [
          {
            extend: "excelHtml5",
            exportOptions: {
              columns: [0, 1, 2],
              modifier: {
                page: 'all'
              }
            }
          }
        ]
      });
    },

    loadDatatable2(tableId) {
      const table = $(`#${tableId}`);
      if ($.fn.DataTable.isDataTable(table)) {
        table.DataTable().destroy();
      }

      table.DataTable({
        pageLength: 10,
        dom: "Bfrtip",
        buttons: [
          {
            extend: "excelHtml5",
            exportOptions: {
              columns: [0, 1, 2, 3, 4, 5, 6],
            },
          },
        ],
      });
    },

    async stopNotification() {
      try {
        const response = await stopMassNotification(this.notification_id, {});

        swal({
          icon: response.data.success ? 'success' : 'error',
          text: response.data.message
        });

        if (response.data.success) {
          this.mass_notification.status = false;
          this.mass_notification.stopped_at = response.data.data.stopped_at;
          this.mass_notification.stopped_at_formatted = response.data.data.stopped_at_formatted;
        }
      } catch (e) {
        console.error(e);
      }
    },

    initializeCurrentTable() {
      ['general-table', 'existing-table', 'non-existing-table', 'newly-register-table', 'notification-purchases-table', 'notification-redeem-table'].forEach(tableId => {
        if ($.fn.DataTable.isDataTable(`#${tableId}`)) {
          $(`#${tableId}`).DataTable().destroy();
        }
      });

      if (this.selectedIndex === 0) {
        this.$nextTick(() => this.loadDatatable('general-table'));
      } else if (this.selectedIndex === 1) {
        this.$nextTick(() => this.loadDatatable('existing-table'));
      } else if (this.selectedIndex === 2) {
        this.$nextTick(() => this.loadDatatable('non-existing-table'));
      } else if (this.selectedIndex === 3) {
        this.$nextTick(() => this.loadDatatable('newly-register-table'));
      } else if (this.selectedIndex === 4) {
        this.$nextTick(() => this.loadDatatable2('notification-purchases-table'));
      } else if (this.selectedIndex === 5) {
        this.$nextTick(() => this.loadDatatable2('notification-redeem-table'));
      }
    },

    initializeData() {
      ['existing-table', 'non-existing-table', 'newly-register-table', 'notification-purchases-table', 'notification-redeem-table'].forEach(tableId => {
        if ($.fn.DataTable.isDataTable(`#${tableId}`)) {
          $(`#${tableId}`).DataTable().destroy();
        }
      });

      if(this.selectIndexNonExcel === 1) {
        this.$nextTick(() => this.loadDatatable('existing-table'));
      } else if(this.selectIndexNonExcel === 2) {
        this.$nextTick(() => this.loadDatatable('non-existing-table'));
      } else if(this.selectIndexNonExcel === 3) {
        this.$nextTick(() => this.loadDatatable('newly-register-table'));
      } else if (this.selectIndexNonExcel === 4) {
        this.$nextTick(() => this.loadDatatable('notification-purchases-table'));
      } else if (this.selectIndexNonExcel === 5) {
        this.$nextTick(() => this.loadDatatable('notification-redeem-table'));
      }
    },

    updateData(updatedMainData) {
      this.data = updatedMainData;
    }
  },

  async mounted() {
    await this.fetchData();
    this.useExcel
    ? this.initializeCurrentTable()
    : this.initializeData();
  }
}

</script>
